import { render } from "./EmptyLayout.vue?vue&type=template&id=62297103"
const script = {}

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__